import {Outlet, useLocation} from 'react-router-dom';
import {useUserClaims} from '../hooks/useUserClaims';
import LoginButton from './LoginButton';
import {t} from 'i18next';
import {RoutePath} from '../lib/enums';
import {DEBUGMODE} from '../utils/constants';

export const Authorization = () => {
  const {userClaims, loading} = useUserClaims();
  const location = useLocation();

  const returnUrl = location.pathname.includes(RoutePath.MyPages) ? location.pathname : RoutePath.HomePage;

  if (loading) {
    return DEBUGMODE ? <>Laddar...</> : <></>;
  }

  return userClaims ? (
    <Outlet />
  ) : (
    <div>
      <h4>{t('header.notLoggedIn')}</h4>
      <p style={{marginBottom: 'var(--space-2xl)'}}>{t('booking.notLoggedInInfo')}</p>
      <LoginButton title={t('button.logIn')} returnUrl={returnUrl} />
    </div>
  );
};
